import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { CactusModal, DashboardTitle, DashboardWrapper, SearchDebounce, ModalDeleteConfirm } from '../../components';
import Screen, { getScreenOption } from '../../models/Screen';
import * as actionCreator from "../../actions";
import ScheduleModel from "../../models/Schedule";
import ScreenService from "../../services/use_case/screen/ScreenService";

import ApiResponse from '../../services/ApiResponse';
import { AxiosResponse } from 'axios';

import Option from "../../models/Option";
import PlaylistService from '../../services/use_case/playlist/PlaylistService';
import Playlist, { getOption } from '../../models/Playlist';

import { Calendar, momentLocalizer, Event } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/es';
import CustomCalendarToolBar from '../../components/CustomCalendarToolBar';

import { registerLocale } from "react-datepicker";
import es from 'date-fns/locale/es';

import ScheduleService from '../../services/use_case/schedule/ScheduleService';
import ScreenGroup, { getScreenGroupOption } from '../../models/ScreenGroup';
import ScreenGroupService from '../../services/use_case/screengroup/ScreenGroupService';

import InfiniteScroll from 'react-infinite-scroller';
import { IconLoader } from '../../assets/icons/IconLoader';
import CustomEvent from '../../components/CustomEvent';

import CreateEditSchedule from '../../components/CreateEditSchedule';
import RenderUser from '../../components/RenderUser';
import ScheduleTimelineView from '../../components/ScheduleTimelineView/ScheduleTimelineView';

let lang = localStorage.getItem("i18nextLng")?.split('-')[0] ?? "en";

moment.locale(lang);


let screenService: ScreenService;
let screenGroupService: ScreenGroupService;

export interface ScheduleEvent extends Event {
    id: string;
    linked_id: string;
    priority: number;
    device_id: string;
    device_type: string;
    device_name: string;
    start_time?: string;
    end_time?: string;
    is_always_schedule: boolean;
    is_time_slot: boolean;
    showDays: string[];
}
export interface ScheduleInputs {
    name: string;
    devide_id: string;
    linked_id: string;
    start_date: string;
    end_date?: string;
    start_time?: string;
    end_time?: string;
    priority: number;
    showDays: string[];
}

interface ScheduleProps { }

const Schedule: React.FC<ScheduleProps> = (props: ScheduleProps) => {

    lang = localStorage.getItem("i18nextLng")?.split('-')[0] ?? "en";

    const [t] = useTranslation();
    const [search, setSearch] = useState<string>("");

    const [screenSelected, setScreenSelected] = useState<Screen | null>(null);
    const [screengroupSelected, setScreengroupSelected] = useState<ScreenGroup | null>(null);
    const [schedules, setSchedules] = useState<ScheduleModel[]>([]);
    const [scheduleDate, setScheduleDate] = useState(new Date());

    const [scheduleForm, setScheduleForm] = useState(false);
    const [updatingSchedule, setUpdatingSchedule] = useState(false);
    const [deletingScheduleForm, setDeletingScheduleForm] = useState(false);

    const [selectedScheduleEvent, setSelectedScheduleEvent] = useState<ScheduleEvent | null>(null);

    const [playlistValue, setPlaylistValue] = useState<Option | null>(null);
    const [showDays] = useState<Option[]>([
        { value: 'monday', label: t('Monday') },
        { value: 'tuesday', label: t('Tuesday') },
        { value: 'wednesday', label: t('Wednesday') },
        { value: 'thursday', label: t('Thursday') },
        { value: 'friday', label: t('Friday') },
        { value: 'saturday', label: t('Saturday') },
        { value: 'sunday', label: t('Sunday') },
    ]);

    const [PanelNavLink, setPanelNavLink] = useState<number>(0);
    const [showSchedule, setShowSchedule] = useState<boolean>(false);
    const [scheduleViewMode, setScheduleViewMode] = useState<'timeline' | 'calendar'>('timeline');

    const [isLoadingCreateSchedule] = useState(false);
    const dispatch = useDispatch();

    const screenReducer = useSelector((state: any) => state.screenReducer);
    const screenPagination: any = screenReducer?.data;
    const screenData: any = screenPagination?.data ?? [];
    const isLoadingScreen = screenReducer?.isLoading;

    const screengroupReducer = useSelector((state: any) => state.screenGroupReducer);
    const screengroupPagination: any = screengroupReducer?.data;
    const screengroupData: any = screengroupPagination?.data ?? [];
    const isLoadingScreengroup = screengroupReducer?.isLoadingScreenGroup;

    let playlistService: PlaylistService;

    moment.locale(lang);
    const localizer = momentLocalizer(moment);

    registerLocale('es', es);

    useEffect(() => {
        _fetchScreens(1);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!screenSelected) {
            setSchedules([]);
            return;
        }
        if (!screengroupSelected) {
            setSchedules([]);
            return;
        }
    }, [screenSelected]);

    useEffect(() => {
        if (!scheduleForm) {
            return;
        }
    }, [scheduleForm]);

    const getDaysOfWeekMap = (lang: string): { [key: string]: number } => {
        const weekStartMonday = moment.localeData(lang).firstDayOfWeek() === 1;

        return weekStartMonday
            ? {
                monday: 0, tuesday: 1, wednesday: 2, thursday: 3,
                friday: 4, saturday: 5, sunday: 6,
            }
            : {
                sunday: 0, monday: 1, tuesday: 2, wednesday: 3,
                thursday: 4, friday: 5, saturday: 6,
            };
    };

    const _fetchScreens = (page?: number) => {
        dispatch(actionCreator.screenCancelRequest());
        dispatch(actionCreator.screenFetch(page, search));
    };

    const _fetchScreengroups = (page?: number) => {
        dispatch(actionCreator.screenCancelRequest());
        dispatch(actionCreator.screenGroupFetch(page, search));
    };

    const fetchscreenSchedule = async (id: string) => {
        screenService?.cancelRequest();
        screenService = new ScreenService();

        try {
            const response = await screenService.schedulesByScreenId(id);
            const screenWithSchedule = response.data?.data?.data ?? [];
            setSchedules(screenWithSchedule);
        } catch (error) { }
    };

    const fetchScreengroupSchedule = async (id: string) => {
        screenGroupService?.cancelRequest();
        screenGroupService = new ScreenGroupService();

        try {
            const response = await screenGroupService.schedulesByScreenGroupId(id);
            const screengroupWithSchedule = response.data?.data?.data ?? [];
            setSchedules(screengroupWithSchedule);
        } catch (error) { }
    };

    const _handleCreateSchedule = () => {
        setSelectedScheduleEvent(null);
        setScheduleForm(true);
        setPlaylistValue(null);
    };

    const _handleUpdateSchedule = async (scheduleEvent: ScheduleEvent) => {
        playlistService = new PlaylistService();
        const response: any = await playlistService.show(scheduleEvent.linked_id);

        const data: Playlist = response.data?.data ?? null;
        const playlist = getOption(data);

        if (playlist) setPlaylistValue(playlist);

        const eventFromList = schedules.find(s => s.id === scheduleEvent.id);
        if (eventFromList) {
            setSelectedScheduleEvent({
                ...scheduleEvent,
                start: new Date(eventFromList.start_date),
                end: eventFromList.end_date ? new Date(eventFromList.end_date) : undefined,
            });
        } else {
            setSelectedScheduleEvent(scheduleEvent);
        }

        setScheduleForm(true);
    };

    const showScreenSchedule = (screen: Screen) => {
        setScreenSelected(screen);
        setShowSchedule(true);
        fetchscreenSchedule(screen.id);
    };

    const showScreenGroupSchedule = (screengroup: ScreenGroup) => {
        setScreengroupSelected(screengroup);
        setShowSchedule(true);
        fetchScreengroupSchedule(screengroup.id);
    };

    const _renderScreens = () => {
        if (isLoadingScreen) return (
            <div className="d-flex justify-content-center pt-4">
                <IconLoader class='stroke-gray-light' styles={{ width: '36px', height: '36px' }} />
            </div>
        );

        const screens: Screen[] = screenData ?? [];

        if (screens.length === 0) {
            return <div className="schedule-no-result">{t('No Result')}</div>;
        }

        return (
            <InfiniteScroll
                pageStart={screenPagination?.from}
                loadMore={() => {
                    _fetchScreens(screenPagination?.current_page ? screenPagination?.current_page + 1 : 1);
                }}
                hasMore={screenPagination?.next_page_url !== null}
                loader={
                    <div key="loading" className="d-flex justify-content-center py-2">
                        <IconLoader class='stroke-gray-light' styles={{ width: '32px', height: '32px' }} />
                    </div>
                }
            >
                {screens.map((screen: Screen) => {
                    const isActive = screen.id === screenSelected?.id;
                    return (
                        <div
                            key={screen.id}
                            className={`schedule-screen-item${isActive ? ' schedule-screen-item--active' : ''}`}
                            onClick={() => showScreenSchedule(screen)}
                        >
                            <i className="iconsminds-monitor schedule-screen-item__icon" />
                            <div className="schedule-screen-item__info">
                                <div className="schedule-screen-item__name">{screen.name}</div>
                                <div className="schedule-screen-item__meta">
                                    <RenderUser item={screen} subtitle={true} />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </InfiniteScroll>
        );
    };

    const _renderScreenGroups = () => {
        if (isLoadingScreengroup) return (
            <div className="d-flex justify-content-center pt-4">
                <IconLoader class='stroke-gray-light' styles={{ width: '36px', height: '36px' }} />
            </div>
        );

        const screengroups: ScreenGroup[] = screengroupData ?? [];

        if (screengroups.length === 0) {
            return <div className="schedule-no-result">{t('No Result')}</div>;
        }

        return (
            <InfiniteScroll
                pageStart={screengroupPagination?.from}
                loadMore={() => {
                    _fetchScreengroups(screengroupPagination?.current_page ? screengroupPagination?.current_page + 1 : 1);
                }}
                hasMore={screengroupPagination?.next_page_url !== null}
                loader={
                    <div key="loading" className="d-flex justify-content-center py-2">
                        <IconLoader class='stroke-gray-light' styles={{ width: '32px', height: '32px' }} />
                    </div>
                }
            >
                {screengroups.map((screengroup: ScreenGroup) => {
                    const isActive = screengroup.id === screengroupSelected?.id;
                    return (
                        <div
                            key={screengroup.id}
                            className={`schedule-screen-item${isActive ? ' schedule-screen-item--active' : ''}`}
                            onClick={() => showScreenGroupSchedule(screengroup)}
                        >
                            <i className="iconsminds-monitor---laptop schedule-screen-item__icon" />
                            <div className="schedule-screen-item__info">
                                <div className="schedule-screen-item__name">{screengroup.name}</div>
                                <div className="schedule-screen-item__meta">
                                    <RenderUser item={screengroup} subtitle={true} />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </InfiniteScroll>
        );
    };

    const _handleOnSubmit = async (json: any) => {
        let options = null;

        if (screenSelected) options = getScreenOption(screenSelected);
        if (screengroupSelected) options = getScreenGroupOption(screengroupSelected);

        json.linked_id = playlistValue?.value ?? "";
        json.linked_type = playlistValue?.type ?? "";

        json.start_date = new Date(json.start_date).toUTCString();
        if (json.end_date && json.end_date !== "") {
            json.end_date = new Date(json.end_date).toUTCString();
        } else {
            json.end_date = null;
        }

        if (!json.useEndDate) json.end_date = null;
        if (!json.useCustomTimeSlots) {
            json.start_time = null;
            json.end_time = null;
        }
        if (json.show_days.length === 0) json.show_days = null;

        try {
            if (selectedScheduleEvent?.id && updatingSchedule) {
                json["device_id"] = selectedScheduleEvent.device_id ?? "";
                json["device_type"] = selectedScheduleEvent.device_type ?? "";
                let response: AxiosResponse<ApiResponse<ScheduleModel>> = await new ScheduleService().update(selectedScheduleEvent?.id, json);
                const scheduleResponse = response.data.data;
                setSchedules((prevState: ScheduleModel[]) => {
                    prevState.forEach((schedule: ScheduleModel) => {
                        if (schedule.id === selectedScheduleEvent.id && scheduleResponse) {
                            schedule.name = scheduleResponse.name;
                            schedule.start_date = scheduleResponse.start_date;
                            schedule.end_date = scheduleResponse.end_date;
                            schedule.linked_id = scheduleResponse.linked_id;
                            schedule.priority = scheduleResponse.priority;
                            schedule.show_days = scheduleResponse.show_days;
                            schedule.start_time = scheduleResponse.start_time;
                            schedule.end_time = scheduleResponse.end_time;
                            schedule.is_always_schedule = scheduleResponse.is_always_schedule;
                            schedule.is_time_slot = scheduleResponse.is_time_slot;
                        }
                    });
                    return prevState;
                });
            } else {
                json["device_id"] = options?.value ?? "";
                json["device_type"] = options?.type ?? "";
                let response: AxiosResponse<ApiResponse<ScheduleModel>> = await new ScheduleService().store(json);
                const scheduleResponse = response.data.data;
                setSchedules((schedules: ScheduleModel[]) => schedules.concat(scheduleResponse ?? []));
            }
        } catch (err) { }

        setScheduleForm(false);
    };

    const _deleteSchedule = async () => {
        if (!selectedScheduleEvent) return;

        try {
            await new ScheduleService().delete(selectedScheduleEvent.id);
            setDeletingScheduleForm(false);
            setScheduleForm(false);
            setSchedules((prevState: ScheduleModel[]) =>
                prevState.filter((state: ScheduleModel) => state.id !== selectedScheduleEvent.id)
            );
        } catch (error) { }
    };

    const _handleDateChange = (newDate: Date) => {
        setScheduleDate(newDate);
    };

    const handlePlaylistChange = (playlistValue: Option | null) => {
        setPlaylistValue(playlistValue);
    };

    const getEventsFromSchedule = (schedule: ScheduleModel): ScheduleEvent[] => {
        const start = moment(schedule.start_date);
        const end = schedule.end_date ? moment(schedule.end_date) : moment('9999-12-31');
        const daysOfWeekMap = getDaysOfWeekMap(lang);

        const deviceName = schedule.device_type === 'App\\Models\\Screen'
            ? screenData.find((s: Screen) => s.id === schedule.device_id)?.name ?? ''
            : screengroupData.find((g: ScreenGroup) => g.id === schedule.device_id)?.name ?? '';

        const allDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
        const selectedDays: string[] = schedule.show_days === null ? allDays : schedule.show_days;
        const hasAllDays = selectedDays.length === allDays.length;

        const events: ScheduleEvent[] = [];

        const createEvent = (eventStart: moment.Moment, eventEnd: moment.Moment) => {
            if (eventStart.isBefore(start) || eventStart.isSameOrAfter(end)) return;

            events.push({
                id: schedule.id,
                title: schedule.name,
                device_id: schedule.device_id,
                device_type: schedule.device_type,
                device_name: deviceName,
                linked_id: schedule.linked_id,
                priority: schedule.priority,
                start: eventStart.toDate(),
                end: eventEnd.toDate(),
                start_time: schedule.start_time,
                end_time: schedule.end_time,
                is_always_schedule: schedule.is_always_schedule,
                is_time_slot: schedule.is_time_slot,
                showDays: selectedDays,
            });
        };

        if (!schedule.is_time_slot && hasAllDays) {
            createEvent(start, end);
            return events;
        }

        const currentWeekStart = moment(scheduleDate).startOf('week');

        selectedDays.forEach((dayKey) => {
            const weekday = daysOfWeekMap[dayKey];
            if (weekday === undefined) return;

            const targetDate = moment(currentWeekStart).weekday(weekday);
            const isStartDateDay = start.isSame(targetDate, 'day');
            const isEndDateDay = end.isSame(targetDate, 'day');

            if (!targetDate.isBetween(
                start.clone().startOf('day').subtract(1, 'second'),
                end.clone().endOf('day').add(1, 'second'),
                undefined, '[]'
            )) return;

            if (schedule.is_time_slot && schedule.start_time && schedule.end_time) {
                const [startHour, startMin] = schedule.start_time.split(':').map(Number);
                const [endHour, endMin] = schedule.end_time.split(':').map(Number);

                const crossesMidnight = endHour < startHour || (endHour === startHour && endMin <= startMin);

                const start1 = moment(targetDate).hour(startHour).minute(startMin).second(0);
                const end1 = crossesMidnight
                    ? moment(targetDate).endOf('day')
                    : moment(targetDate).hour(endHour).minute(endMin).second(0);
                createEvent(start1, end1);

                if (crossesMidnight) {
                    const nextDay = moment(targetDate).add(1, 'day');
                    const nextDayKey = Object.keys(daysOfWeekMap).find(k => daysOfWeekMap[k] === nextDay.weekday());
                    const shouldRenderNextDay = nextDayKey && selectedDays.includes(nextDayKey);

                    if (shouldRenderNextDay && nextDay.isBetween(
                        start.clone().startOf('day').subtract(1, 'second'),
                        end.clone().endOf('day').add(1, 'second'),
                        undefined, '[]'
                    ) && nextDay.isSame(currentWeekStart, 'week')) {
                        createEvent(moment(nextDay).startOf('day'), moment(nextDay).hour(endHour).minute(endMin).second(0));
                    }

                    const prevDay = moment(targetDate).subtract(1, 'day');
                    const prevDayKey = Object.keys(daysOfWeekMap).find(k => daysOfWeekMap[k] === prevDay.weekday());
                    const prevSelected = prevDayKey && selectedDays.includes(prevDayKey);

                    if (prevSelected && prevDay.isBetween(
                        start.clone().startOf('day').subtract(1, 'second'),
                        end.clone().endOf('day').add(1, 'second'),
                        undefined, '[]'
                    ) && !prevDay.isSame(currentWeekStart, 'week')) {
                        createEvent(
                            moment(targetDate).startOf('day'),
                            moment(targetDate).hour(endHour).minute(endMin).second(0)
                        );
                    }
                }
            } else {
                const eventStart = isStartDateDay
                    ? moment(targetDate).hour(start.hour()).minute(start.minute()).second(0)
                    : moment(targetDate).startOf('day');
                const eventEnd = isEndDateDay
                    ? moment(targetDate).hour(end.hour()).minute(end.minute()).second(0)
                    : moment(targetDate).hour(23).minute(59).second(0);
                createEvent(eventStart, eventEnd);
            }
        });

        return events;
    };

    const _renderSchedule = () => {
        if (!showSchedule) {
            return (
                <div className="schedule-empty">
                    <i className="iconsminds-calendar-4 schedule-empty__icon" />
                    <div className="schedule-empty__title">{t('Schedule')}</div>
                    <div className="schedule-empty__subtitle">
                        {t('Select a screen or group to view and manage its schedule')}
                    </div>
                </div>
            );
        }

        const events: ScheduleEvent[] = schedules.flatMap((schedule: ScheduleModel) => getEventsFromSchedule(schedule)).sort((a, b) => a.priority - b.priority);
        const selectedName = screenSelected?.name ?? screengroupSelected?.name ?? '';
        const isGroup = !!screengroupSelected && !screenSelected;

        return (
            <div className='schedule-view sticky-top' style={{ top: '90px' }}>
                <div className='schedule__toolbar'>
                    <div className="schedule__selected-label">
                        <strong>{isGroup ? t('Group Screen Selected') : t('Screen Selected')}:</strong>
                        <strong>{selectedName}</strong>
                    </div>
                    <div className="schedule__toolbar-right">
                        <div className="rbc-toolbar-views">
                            <button
                                type="button"
                                className={`rbc-toolbar-view-btn${scheduleViewMode === 'timeline' ? ' rbc-toolbar-view-btn--active' : ''}`}
                                onClick={() => setScheduleViewMode('timeline')}
                            >
                                {t('Timeline')}
                            </button>
                            <button
                                type="button"
                                className={`rbc-toolbar-view-btn${scheduleViewMode === 'calendar' ? ' rbc-toolbar-view-btn--active' : ''}`}
                                onClick={() => setScheduleViewMode('calendar')}
                            >
                                {t('Calendar')}
                            </button>
                        </div>
                        <button
                            className='btn btn-success'
                            disabled={isLoadingScreen}
                            onClick={_handleCreateSchedule}
                        >
                            <i className="simple-icon-plus" />
                            {t('New_schedule')}
                        </button>
                    </div>
                </div>

                {scheduleViewMode === 'timeline' ? (
                    <ScheduleTimelineView
                        events={events}
                        date={scheduleDate}
                        onSelectEvent={_handleUpdateSchedule}
                        onNavigate={_handleDateChange}
                    />
                ) : (
                    <Calendar
                        localizer={localizer}
                        events={events}
                        date={scheduleDate}
                        drilldownView={null}
                        startAccessor="start"
                        endAccessor="end"
                        showMultiDayTimes={true}
                        views={['week', 'day']}
                        defaultView='week'
                        step={60}
                        timeslots={1}
                        dayLayoutAlgorithm="no-overlap"
                        onSelectEvent={_handleUpdateSchedule}
                        components={{ event: CustomEvent, toolbar: CustomCalendarToolBar }}
                        onNavigate={_handleDateChange}
                        eventPropGetter={(event: ScheduleEvent) => {
                            const deviceClass = event.device_type === 'App\\Models\\ScreenGroup'
                                ? 'rbc-screengroup-event'
                                : '';
                            const priorityClass = `rbc-event--priority-${event.priority}`;
                            return { className: `${deviceClass} ${priorityClass}`.trim() };
                        }}
                    />
                )}
            </div>
        );
    };

    const _renderPanelBody = () => {
        if (PanelNavLink === 0) return _renderScreens();
        if (PanelNavLink === 1) return _renderScreenGroups();
        return null;
    };

    return (
        <DashboardWrapper>
            <DashboardTitle title={t('Schedule')} isLoading={isLoadingScreen} />

            <div className="schedule">
                <div className="schedule__filter">
                    <SearchDebounce
                        placeholder={`${t('Name')}`}
                        borderColor="transparent"
                        onChange={(text: string) => {
                            setSearch(text);
                            setScreenSelected(null);
                        }}
                        debounceFinish={(text: string) => _fetchScreens(1)}
                    />
                </div>

                <div className="schedule__screens">
                    <div className="schedule-panel-nav">
                        <button
                            className={`schedule-panel-nav__btn${PanelNavLink === 0 ? ' schedule-panel-nav__btn--active' : ''}`}
                            onClick={() => {
                                setPanelNavLink(0);
                                setShowSchedule(false);
                                setScreengroupSelected(null);
                            }}
                        >
                            {t('Screens')}
                        </button>
                        <button
                            className={`schedule-panel-nav__btn${PanelNavLink === 1 ? ' schedule-panel-nav__btn--active' : ''}`}
                            onClick={() => {
                                setPanelNavLink(1);
                                setShowSchedule(false);
                                setScreenSelected(null);
                                _fetchScreengroups(1);
                            }}
                        >
                            {t('Screen Groups')}
                        </button>
                    </div>
                    {_renderPanelBody()}
                </div>

                <div className='schedule__content mt-1'>
                    {_renderSchedule()}
                </div>

                <CactusModal
                    show={scheduleForm}
                    title={selectedScheduleEvent?.id ? t('Edit_schedule') : t('New_schedule')}
                    onClose={() => setScheduleForm(false)}
                    minWidth="500px"
                    minHeight="500px"
                    overflow='visible'
                >
                    <div>
                        <CreateEditSchedule
                            disabled={false}
                            selectedScheduleEvent={selectedScheduleEvent}
                            playlistValue={playlistValue}
                            showDays={showDays}
                            setUpdatingSchedule={setUpdatingSchedule}
                            setDeletingScheduleForm={setDeletingScheduleForm}
                            onPlaylistChange={handlePlaylistChange}
                            onSubmit={_handleOnSubmit}
                        />
                    </div>
                </CactusModal>

                <ModalDeleteConfirm
                    show={deletingScheduleForm}
                    title={t('Delete_schedule')}
                    onCloseFunction={setDeletingScheduleForm}
                    onCloseFunctionParameter={false}
                    entityTranslation={t('schedule')}
                    buttonLoading={isLoadingCreateSchedule}
                    onClickFunctionButton={_deleteSchedule}
                    buttonText={t('Delete')}
                />
            </div>

        </DashboardWrapper>
    );

};

export default React.memo(Schedule);
